import React from 'react';
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';
import './UsersPage.css';

const UsersPage = () => {
  const userTypes = [
    {
      title: 'Agents (Buyer\'s and Seller\'s)',
      icon: '💼',
      description: 'Manage listings, offers, and client communications while ensuring all documents and deadlines are tracked automatically.'
    },
    {
      title: 'Clients (Buyers and Sellers)',
      icon: '🏡',
      description: 'Get guided visibility into their transaction progress, document signing, and key dates, all in one place.'
    },
    {
      title: 'Brokers',
      icon: '📊',
      description: 'Oversee agent performance and ensure compliance through transparent dashboards and proactive alerts.'
    },
    {
      title: 'Third-Party Service Providers',
      icon: '🤝',
      description: 'Seamlessly collaborate on inspections, appraisals, loans, and escrow processes via integrated access.'
    }
  ];

  return (
    <div className="users-page">
      <section className="page-header">
        <div className="container">
          <h1>Our Users</h1>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="users-intro">
            <p>
              The Rialty Platform serves a diverse ecosystem of real estate professionals and clients involved in property transactions. Each user interacts with RIA, the AI-powered Transaction Coordinator, to streamline their specific workflows and improve efficiency.
            </p>
          </div>

          <div className="primary-users-section">
            <h2>Primary Users:</h2>
          </div>

          <div className="users-grid">
            {userTypes.map((userType, index) => (
              <div key={index} className="card user-type-card">
                <div className="user-icon">{userType.icon}</div>
                <h3>{userType.title}</h3>
                <p className="user-description">{userType.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default UsersPage;
